<template>
  <div class="vehicle-detail">
    <wrld-container
      :breadcrumbs="this.breadcrumbs"
      :pageIsLoading="pageIsLoading"
    >
      <div v-if="vehicles.error !== null">
        <!-- TODO: add to i18n -->
        <h2>Vehicle with ID {{route.params.vehicleID}} does not exist or you do not have permission to see it.</h2>
      </div>
      <div v-else>
        <wrld-out-of-box :title="$t('fleet.vehicle') + ' - ' + vehicle.licence_plate">
          <template v-slot:headerBtns>
            <v-btn class="mr-4" outlined @click="gotoEditVehicle">
              <v-icon>edit</v-icon>{{$t('buttons.edit')}}
            </v-btn>
            <wrld-confirm-btn v-model="delete_modal_opened" @confirm="callDeleteVehicle()">
              <v-btn class="mr-4" outlined color="accent" @click="delete_modal_opened=true">
                <v-icon>delete</v-icon>{{$t('buttons.delete')}}
              </v-btn>
            </wrld-confirm-btn>
          </template>
        </wrld-out-of-box>
        <VehicleDetailOverview :vehicleOverview="vehicle"/>
        <VehicleDetailProperties :vehicleProperties="vehicle.properties"/>
      </div>
    </wrld-container>
  </div>
</template>

<script>
import router from '@/router'
import { mapState, mapActions } from 'vuex'
import VehicleDetailOverview from '@/components/fleet/VehicleDetailOverview'
import VehicleDetailProperties from '@/components/fleet/VehicleDetailProperties'
import { companyService } from '@/_services'

export default {
  name: 'VehicleDetail',
  components: {
    VehicleDetailOverview,
    VehicleDetailProperties
  },
  data () {
    return {
      vehicle: {},
      delete_modal_opened: false,
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' }
      ],
      pageIsLoading: false
    }
  },
  computed: {
    ...mapState(['route', 'vehicles', 'signedInCompany'])
  },
  methods: {
    ...mapActions({
      fetchVehicles: 'fetchVehicles',
      fetchVehicleByID: 'fetchVehicleByID',
      deleteVehicle: 'deleteVehicle',
      showSnackbar: 'showSnackbar'
    }),
    gotoEditVehicle () {
      router.push({
        name: 'VehicleUpdate',
        params: { vehicleID: this.vehicle.id }
      })
    },
    callDeleteVehicle () {
      this.deleteVehicle(this.vehicle.id)
      let snackMsg = ''
      let snackColor = ''
      if (this.vehicles.error) {
        snackMsg = this.$i18n.t('snacbars.error')
        snackColor = 'errorr'
      } else {
        snackMsg = this.$i18n.t('snackbars.location_deleted')
        snackColor = 'success'
      }
      this.showSnackbar({ message: snackMsg, color: snackColor })
      if (this.vehicle.is_internal) {
        router.push({ name: 'InternalFleet' })
      } else {
        router.push({ name: 'ExternalFleet' })
      }
    },
    async fetchData () {
      this.pageIsLoading = true
      let vehicleID = this.route.params.vehicleID
      if (this.vehicles.data[vehicleID] == null) {
        // TODO: get vehicle by ID from server if no index found
        await this.fetchVehicles()
        // await this.fetchVehicleByID(vehicleID)
      }
      this.vehicle = this.vehicles.data[vehicleID]
      if (this.vehicle != null && this.vehicle.is_internal) {
        this.breadcrumbs.push({ text: this.$i18n.t('fleet.internal_fleet'), disabled: false, href: '#/internal-fleet' })
        this.breadcrumbs.push({ text: this.$i18n.t('fleet.vehicle_detail'), disabled: true })
      } else if (this.vehicle != null) {
        this.breadcrumbs.push({ text: `${this.vehicle.name}: ${this.$i18n.t('fleet.external_fleet')}`, disabled: false, href: '#/external-fleet' })
        this.breadcrumbs.push({ text: `${this.vehicle.name}: ${this.$i18n.t('fleet.vehicle_detail')}`, disabled: true })
      }
      if (this.vehicle.is_internal && (!this.vehicle.owner || this.vehicle.owner === '')) {
        this.$set(this.vehicle, 'owner', this.signedInCompany.name)
      }

      this.pageIsLoading = false
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
